import http from '../http-common';


class ClientDetails {

    public getClientDetails(){
        const clientDetails: any= {
          token: token
        }
        return http.post("../../selfcare/fetchClientDetails",clientDetails,
        {
            headers: {
              Authorization: 'Basic YWRtaW46Z09Wb24/NlFGKA==',
            },
          })
    }
}
export default new ClientDetails();